import { Component, OnInit } from '@angular/core'

import { GraphqlService } from '@mprep/shared/data/services'
import { DateHelper } from '@mprep/shared/lib/helpers'
import { ZOOM_MAGIC_LINK, Window } from '../shared'

@Component({
  selector: 'mp-class-schedule',
  templateUrl: './class-schedule.html',
  styleUrls: ['./class-schedule.scss']
})
export class ClassScheduleComponent implements OnInit {
  public enrollmentData = {}

  public constructor(
    private _graphQlService: GraphqlService,
    private _dateHelper: DateHelper,
    private _window: Window
  ) {}

  public ngOnInit() {
    this._graphQlService.query('class_schedule').subscribe((data) => {
      this.enrollmentData = data['result']
    })
  }

  public formatAddress(facility: {}, isOnline: boolean) {
    return isOnline ? 'Online' : this._formatAddressString(facility)
  }

  public formatSessionTime(session: {}) {
    const sessionStartDate = this._dateHelper.get(session['sessionDate']).format('YYYY/MM/DD')
    const timezone = session['TimeZone']
    const offset = timezone['rawOffset'] + timezone['dstOffset']
    const startDate = this._dateHelper.get(`${sessionStartDate} ${session['sessionStartTime']} ${offset}`).tz(timezone['timeZoneId'])
    const endDate = this._dateHelper.get(`${sessionStartDate} ${session['sessionEndTime']} ${offset}`).tz(timezone['timeZoneId'])
    return `${startDate.format('hh:mm A')} - ${endDate.format('hh:mm A z')}`
  }

  public formatInstructors(instructors: {}[]) {
    const formattedInstructors = (instructors || []).map((instructor) => `${instructor['teacher']['firstName']} ${instructor['teacher']['lastName']}`)
    return formattedInstructors.join(', ') || 'Instructor to be determined'
  }

  public openClassLink(enrollmentId: string) {
    this._window.instance.open(ZOOM_MAGIC_LINK.replace(':enrollmentId', enrollmentId), '_blank')
  }

  private _formatAddressString(facility: {}) {
    if (!facility) { return 'No Facility Assigned' }
    return `${facility['Location']['address1']} ${facility['Location']['address2'] || ''} ${facility['Location']['city'] || ''} ${facility['Location']['state'] || ''} ${facility['Location']['zip'] || ''}`
  }
}



// WEBPACK FOOTER //
// ./src/app/class-schedule/class-schedule.component.ts